export class CartPromo {
    description: string;
    quantity: number;
    price: number;
    total: number;
    tipoPromo: string;
    tipoRegalo: string;
}

export class CartPromoHelper {
    static create(): CartPromo {
        return {
            description: '',
            quantity: 0,
            price: 0,
            total: 0,
            tipoPromo: null,
            tipoRegalo: null,
        };
    }

    static transformFromApi(apiData: Object): CartPromo {
        const promo = CartPromoHelper.create();
        promo.description = apiData['DESCRIPCION'];
        promo.quantity = apiData['CANTIDAD'];
        promo.price = apiData['PRECIO'];
        promo.total = apiData['TOTAL'];
        promo.tipoPromo = apiData['TIPOPROMO'];
        promo.tipoRegalo = apiData['TIPOREGALO'];
        return promo;
    }
}
